export default "__VITE_ASSET__bc053fbc__"